import { ActeurIcon } from "@logora/parliament.icons.regular_icons";
import {
	formatBooleen,
	formatChambre,
	formatGroupeParlementaire,
	formatActeurSansGroupe,
	formatCell,
	formatRow,
} from "../formatters";

const acteursFields = [
	{
		header: "Chambre",
		accessorKey: "chambre",
		cell: (info) => formatChambre(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Chambre",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{
						value: "AN",
						label: "AN",
					},
					{
						value: "SN",
						label: "SN",
					},
				],
			},
		},
	},
	{
		header: "Nom complet",
		accessorKey: "nom",
		cell: (info) => formatActeurSansGroupe(formatRow(info)),
		defaultSorting: "asc",
	},
	{
		header: "Groupe politique",
		accessorKey: "groupeParlementaire",
		cell: (info) => formatGroupeParlementaire(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Groupe politique",
				variant: "async-select",
				resource: "organes",
				perPage: 30,
				key: "groupeParlementaireUid",
				filters: { type: "Groupe politique", actif: true },
				sort: { field: "chambre", order: "ASC" },
				groupBy: (option) => option?.chambre,
				getOptionLabel: (option) => `${option?.libelle}`,
				getOptionValue: (option) => option?.uid,
			},
		}
	},
	{
		header: "Circonscription",
		accessorKey: "circonscription.libelle",
		accessorFn: (originalRow) => originalRow.circonscription?.libelle,
		enableSorting: false,
	},
	{
		header: "Commission permanente",
		accessorKey: "commissionPermanente.libelle",
		accessorFn: (originalRow) => originalRow.commissionPermanente?.libelle,
		enableSorting: false,
	},
	{
		header: "Sujets favoris",
		accessorKey: "themes",
		enableSorting: false,
	},
	{
		header: "Actif",
		accessorKey: "actif",
		cell: (info) => formatBooleen(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Actif",
				variant: "select",
				defaultValue: true,
				options: [
					{ value: null, label: "Tous" },
					{
						value: true,
						label: "Actif",
					},
					{
						value: false,
						label: "Non actif",
					},
				],
			},
		},
	},
];

export const acteurDataset = {
	key: "acteurs",
	name: "Acteurs",
	columns: acteursFields,
	filterMapping: {
		acteurRefUid: "uid",
		organeRefUid: "groupeParlementaireUid",
	},
	include: ["groupeParlementaire", "commissionPermanente", "circonscription", "mandatPrincipal"],
	icon: <ActeurIcon height={20} width={20} />,
};
